import { Id } from '@shared/types/id';

export class UserContext {
  constructor(
    readonly id: Id,
    readonly email: string
  ) {}
}
